var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBold(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 512,
    height: 512,
    x: 0,
    y: 0,
    viewBox: "0 0 512.047 512.047",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    className: "",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "B"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "var(--current_svg_color)",
    d: "m334.568 507.618c83.832-9.523 131.455-77.588 131.455-150.791 0-52.632-25.84-95.229-70.518-118.681 29.941-24.111 47.651-61.656 47.651-102.174 0-64.556-46.699-119.575-111.05-130.854-45.293-7.877-113.853-4.022-286.083-5.071v511.941c40.109.208 248.486.099 288.545-4.37zm-164.531-397.573c14.517.109 100.222-.508 117.466 1.523 22.998 2.886 34.189 15.366 34.189 38.159 0 28.989-20.977 37.632-38.628 39.785-16.663 2.083-86.313 1.393-113.027 1.523zm0 191.719c26.149.741 115.186-2.538 139.204 5.991 19.644 7.046 29.604 22.002 29.604 44.487 0 24.902-12.466 40.942-35.083 45.176l-.41.088c-18.359 3.934-99.933 2.182-133.315 2.607z"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBold);
export default __webpack_public_path__ + "static/media/bold.1686464d100a6ab0e3fac68dbb31c0c3.svg";
export { ForwardRef as ReactComponent };